<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr"
        max-width="580px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
    >
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <v-alert
                    dense
                    outlined
                    color="info"
                    icon="mdi-alert-circle"
                >
                    Erinnerung für die Terminbestätigung senden?
                </v-alert>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn outlined color="secondary" @click="isOpen = false">Abbrechen</v-btn>
                <v-btn depressed color="info" @click="sendApprovalReminder" class="confirm-delete-btn">Sende Email</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
    import axios from 'axios';
    import { mapMutations } from 'vuex';

    export default {
        props: {
            value: Boolean,
            pharmacistId: String,
        },
        data: () => ({}),
        methods: {
            async sendApprovalReminder() {
                try {
                    await axios.post(`/api/appointments/approval_reminder/${this.pharmacistId}`)
                    this.isOpen = false;
                    this.alertSuccess('Die Aktion wurde erfolgreich abgeschlossen');
                    // window.location.reload()
                } catch (error) {
                    this.alertError()
                }
            },
            ...mapMutations({
                alertError: 'alert/error',
                alertSuccess: 'alert/success'
            })
        },
        computed: {
            isOpen: {
                get() {
                    return this.value
                },
                set(state) {
                    this.$emit('input', state)
                }
            },
        }
    }
</script>

<style scoped>

</style>